"use strict";

import { UIContainer } from "../uiContainer.js";

export class UISlider extends UIContainer {
    constructor(config) {
        let _onInitialize = config.onInitialize;
        config.onInitialize = undefined;
        
        super(config);

        if (config.orientation === undefined) {
            this._orientation = 0;
        } else if (typeof config.orientation === "number") {
            this._orientation = config.orientation != 1 ? 0 : 1;
        } else if (typeof config.orientation === "string") {
            this._orientation = config.orientation != "vertical" ? 0 : 1;
        }

        this.bar = config.bar;
        this.fill = config.fill;
        this.from = config.from;
        this.to = config.to;
        this.indicator = config.indicator;

        this.bar.graphics.rect.anchorX = { min: 0, max: 1 };
        this.bar.graphics.rect.anchorY = { min: 0, max: 1 };

        if (this._orientation == 0) {
            this.from.rect.anchorX = { min: 0, max: 0 };
            this.to.rect.anchorX = { min: 1, max: 1 };

            if (this.fill !== undefined) {
                this.fill.rect.anchorX = { min: 0, max: 0 };
                this.fill.rect.pivot = { x: 0, y: 0.5 };
            }
        } else {
            this.from.rect.anchorY = { min: 1, max: 1 };
            this.to.rect.anchorY = { min: 0, max: 0 };

            if (this.fill !== undefined) {
                this.fill.rect.anchorY = { min: 0, max: 0 };
                this.fill.rect.pivot = { x: 0.5, y: 0 };
            }
        }

        this.bar.setParent(this);
        this.fill?.setParent(this);
        this.from.setParent(this);
        this.to.setParent(this);
        this.indicator.setParent(this);

        this.bar.registerEvent("down", (pointer) => this._onClickedOnBar(pointer));
        this.bar.registerEvent("up", this.releaseControl.bind(this));
        this.bar.registerEvent("upoutside", this.releaseControl.bind(this));

        this.indicator._onDrag = this._onDrag.bind(this);
        this._onSlide = config.onSlide;

        if (config.segments) {
            this._valueCount = config.segments - 1;
            let step = 1 / this._valueCount;
            this._values = [];
            for (let i = 0; i < this._valueCount + 1; i++) {
                this._values.push(i * step);
            }
        }

        this._indicatorOffset = 0;
        if (config.useIndicatorOffset) {
            this.calculateIndicatorOffset();
        }

        this.indicator.delta = config.startDelta ?? 0;
        this._prevDelta = this.delta;
        this._recalcDelta();
        this._updatePosition();
        this._updateFill();

        this._onResolutionWillChangeCallback = () => this._updatePosition();

        this._isEnabled = true;

        if (config.visible !== undefined && !config.visible) {
            this.hide();
        }

        _onInitialize?.bind(this)(config);

        this.ex_onResolutionChanged = super.onResolutionChanged;
        this.onResolutionChanged = this.override_onResolutionChanged;
        this.updateNow();
    }

    get isEnabled() {
        return this._isEnabled;
    }

    get orientation() {
        return this._orientation == 0 ? "horizontal" : "vertical";
    }

    get delta() {
        return this.indicator.delta;
    }
    set delta(value) {
        this.indicator.delta = value;
    }

    get indicatorOffset() {
        return this._indicatorOffset;
    }

    get fromRealWorldX() {
        return this.from.getRealWorldPosition().x + this.indicatorOffset;
    }
    get fromRealWorldY() {
        return this.from.getRealWorldPosition().y + this.indicatorOffset;
    }
    get toRealWorldX() {
        return this.to.getRealWorldPosition().x - this.indicatorOffset;
    }
    get toRealWorldY() {
        return this.to.getRealWorldPosition().y - this.indicatorOffset;
    }

    show(enable) {
        if (this._isEnabled) return;

        this.bar.show(enable);
        this.indicator.show(enable);
        this._isEnabled = true;
    }
    hide() {
        if (!this._isEnabled) return;

        this.bar.hide();
        this.indicator.hide();
        this._isEnabled = false;
    }

    _onPointerUpOutside() {
        this.indicator.onPointerUpOutside();
        this.releaseControl();
    }

    _onClickedOnBar(pointer) {
        let delta = 0;
        if (this._orientation == 0) {
            delta = Math.getDelta(
                pointer.x,
                this.fromRealWorldX,
                this.toRealWorldX
            );
        } else {
            delta = Math.getDelta(
                pointer.y,
                this.fromRealWorldY,
                this.toRealWorldY
            );
        }

        this.takeControl(pointer, delta);
    }
    _onDrag(id,pointer) {
        this.delta = 0;

        if (this._orientation == 0) {
            this.delta = Math.getDelta(
                pointer.x - this.indicator.OffsetX,
                this.fromRealWorldX,
                this.toRealWorldX
            );
        } else {
            this.delta = Math.getDelta(
                pointer.y - this.indicator.OffsetY,
                this.fromRealWorldY,
                this.toRealWorldY
            );
        }
        
        if (!this._recalcDelta()) return;

        this._updatePosition();
        this._updateFill();
        this._onSlide(id, pointer, this.delta);

        this.updateNow();
    }
    setDelta(delta,noCallback) {
        this.delta = delta;
        this._recalcDelta();
        this._updatePosition();
        this._updateFill();
        if (!noCallback) {
            this._onSlide(undefined, undefined, this.delta);
        }

        this.updateNow();
    }
    _recalcDelta() {
        if (this._valueCount !== undefined) {
            let cIndex = 0;
            let cValue = 1;
            for (let i = 0; i < this._values.length; i++) {
                let dist = Math.abs(this._values[i] - this.delta);
                if (dist < cValue) {
                    cIndex = i;
                    cValue = dist;
                }
            }

            this.delta = this._values[cIndex];

            if (this._prevDelta == this.delta) return false;
            
            this._prevDelta = this.delta;
        }
        return true;
    }

    _updatePosition() {
        if (this._orientation == 0) {
            this.indicator.rect.position.x = this.transformFromUI(
                Math.lerp(this.from.x + this.indicatorOffset,
                this.to.x - this.indicatorOffset, this.delta)
            );
        } else {
            this.indicator.rect.position.y = this.transformFromUI(
                Math.lerp(this.to.y - this.indicatorOffset,
                this.from.y + this.indicatorOffset, this.delta)
            );
        }

        this.indicator.updateNow();
    }
    
    _updateFill() {
        if (this.fill === undefined) return;

        if (this._orientation == 0) {
            // Horizontal
            this.fill.rect.size.width = this.transformFromUI(
                (this.to.x - this.from.x) * this.delta);
            return;
        }
        
        // Vertical
        this.fill.rect.size.height = this.transformFromUI(
            (this.to.y - this.from.y) * (1 - this.delta));
    }

    calculateIndicatorOffset() {
        this._indicatorOffset = this._orientation == 0 ?
            this.indicator.graphics.width / 2 :
            this.indicator.graphics.height / 2;
        this._recalcDelta();
        this._updatePosition();
        this._updateFill();
    }

    takeControl(pointer,delta) {
        if (delta !== undefined) {
            this.setDelta(delta);
        }

        this.indicator._onPointerDown(pointer);
        this.indicator._startX = 0;
        this.indicator._startY = 0;

        if (this._valueCount === undefined) return;

        this.indicator._onPointerMove(pointer, false);
    }
    releaseControl() {
        this.indicator._onPointerUp();
    }

    override_onResolutionChanged() {
        if (this._orientation == 0) {
            this.bar.rect.size.width = this.transformFromUI(this.to.x - this.from.x);
        } else {
            this.bar.rect.size.height = this.transformFromUI(this.to.y - this.from.y);
        }
        
        this._updateFill();

        this.ex_onResolutionChanged();
    }
}